import { render, staticRenderFns } from "./index.vue?vue&type=template&id=60a5d4fe&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AboutPage: require('/var/app/components/AboutPage.vue').default})
